import base64 from "crypto-js/enc-base64"
import sha512 from "crypto-js/sha512"
import API from "customerAttachments/utils/apiUtil"

export interface LoginReq {
  account: string
  password: string
}

export interface LoginRes {
  Name: string
}

export const loginApi = ({ account, password }: LoginReq): Promise<LoginRes> => {
  return API.post("/tw/customer/api/auth/login", {
    Account: account,
    Password: base64.stringify(sha512(password)),
  }).then((response) => {
    return response.data.Data
  })
}

export const logoutApi = (): Promise<{ Result: number }> => {
  return API.post("/tw/customer/api/auth/logout").then((response) => {
    return response.data
  })
}
